export default  {
    component: 'plant_overview_component',
    name: 'plant_overview_component',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Module',
            param: 'module',
            type: 'text',
            description: `3 options are provided:
            - card
            - radial
            - widget`
          },
          {
            name: 'Component',
            param: 'component',
            type: 'text',
            description: `Need to add param in comma seperated formated:
            **card** : 
            - daily_inv_gen,prev_inv_gen,month_inv_gen,annual_inv_gen,inv_itd_gen
            - ac_capacity,dc_capacity
            - live_ambient,insolation,ghiInsolation
            - inv_ac_power,inv_dc_power
            - inv_ac_yield,inv_cuf
            - daily_mfm_gen,month_mfm_gen,mfm_peak_load,mfm_ac_yield,mfm_cuf,mfm_ac_power
            - daily_em_gen,month_em_gen,peak_load,ac_yield,cuf,em_ac_power
            - efficiency,data_logger

            **radial** : 
            - pr_inv,em_pr,ac_power,mfm_pr,inv_acYield,inv_cuf

            **widget** : 
            - plant_avail,grid_avail,time,instant_plant_avail,instant_grid_availl,grid_down_time`
          },
          {
            name: 'ID Ref',
            param: 'id_ref',
            type: 'text',
            description: `for how many param has been added that no. of comma's need to be added
            - e.g: ,,,,`
          },
          {
            name: 'Name Ref',
            param: 'name_ref',
            type: 'json',
          }
    ]
  }
